export const pharmacologyConst = {
  path: "/single-programs/pharmacology",
  title: "ФАКУЛЬТЕТ МЕДИЦИНЫ – ФАРМАКОЛОГИЯ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> магистра
      </p>
      <p>
        <strong>Форма обучения:</strong> очная или дистанционная
      </p>
      <p>
        <strong>Форма связи:</strong> получить консультацию приемной комиссии
      </p>
      <h2>Фармакология — наука на грани медицины и химии, которая спасает жизни</h2>
      <p>
        Фармакология — это ключевая дисциплина в системе здравоохранения. Именно она отвечает за понимание того, как действуют лекарства,
        какие эффекты они вызывают, как их правильно применять и как разрабатывать новые препараты. Эта специальность играет решающую роль в
        создании эффективной и безопасной терапии.
      </p>
      <p>
        Магистерская программа по фармакологии сочетает фундаментальные знания о биохимии и физиологии с практическими навыками клинической
        оценки лекарств. Студенты изучают фармакодинамику, фармакокинетику, безопасность препаратов, взаимодействие веществ и нормативное
        регулирование обращения ЛС.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Общая и клиническая фармакология</li>
        <li>Фармакокинетика и фармакодинамика</li>
        <li>Методы доклинических и клинических испытаний </li>
        <li>Побочные эффекты и токсикология</li>
        <li>Разработка, регистрация и маркетинг лекарственных средств</li>
        <li>Биостатистика и анализ медицинских данных</li>
        <li>Этические и правовые нормы в фармакологической практике</li>
        <li>Международные стандарты (GCP, EMA, FDA)</li>
      </ul>
      <p>
        Программа включает теорию, лабораторные исследования, моделирование клинических испытаний, а также практику в фармкомпаниях, НИИ и
        клиниках.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Клинический фармаколог в стационаре</li>
        <li>Специалист по регистрации и оценке ЛС</li>
        <li>Научный сотрудник в НИИ или фармлаборатории</li>
        <li>Консультант по безопасности и эффективности терапии</li>
        <li>Специалист по фармаконадзору</li>
        <li>Менеджер проектов в фармацевтической компании</li>
      </ul>
      <h2>Средний доход в Европе:</h2>
      <p>
        от <strong>€50,000 до €95,000 в год,</strong> в зависимости от специализации и страны.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом, признанный во всех странах ЕС</li>
        <li>Гибкий формат обучения — очно или дистанционно</li>
        <li>Современные лаборатории и цифровые симуляторы</li>
        <li>Преподаватели с опытом работы в международных фармкомпаниях</li>
        <li>Стажировки и исследовательская практика</li>
        <li>Обучение на английском или русском языке</li>
      </ul>
      <p>
        Фармакология — это точная наука с глобальным влиянием. Мы готовим специалистов, которые стоят за созданием и контролем новых
        лекарств, способных изменить жизнь миллионов.
      </p>
      <h2>Как поступить?</h2>
      <p>Приёмная комиссия поможет вам выбрать подходящую форму обучения, собрать документы и пройти весь путь поступления шаг за шагом.</p>
    </>
  ),
  contentSearch: `
    Диплом: магистра
    Формы обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии
    Фармакология — наука на грани медицины и химии, которая спасает жизни
    Фармакология — это ключевая дисциплина в системе здравоохранения. Именно она отвечает за понимание того, как действуют лекарства, какие эффекты они вызывают, как их правильно применять и как разрабатывать новые препараты. Эта специальность играет решающую роль в создании эффективной и безопасной терапии.
    Магистерская программа по фармакологии сочетает фундаментальные знания о биохимии и физиологии с практическими навыками клинической оценки лекарств. Студенты изучают фармакодинамику, фармакокинетику, безопасность препаратов, взаимодействие веществ и нормативное регулирование обращения ЛС.

    Что вы будете изучать?
    • Общая и клиническая фармакология
    • Фармакокинетика и фармакодинамика
    • Методы доклинических и клинических испытаний
    • Побочные эффекты и токсикология
    • Разработка, регистрация и маркетинг лекарственных средств
    • Биостатистика и анализ медицинских данных
    • Этические и правовые нормы в фармакологической практике
    • Международные стандарты (GCP, EMA, FDA)
    Программа включает теорию, лабораторные исследования, моделирование клинических испытаний, а также практику в фармкомпаниях, НИИ и клиниках.

    Кем можно работать после окончания?
    • Клинический фармаколог в стационаре
    • Специалист по регистрации и оценке ЛС
    • Научный сотрудник в НИИ или фармлаборатории
    • Консультант по безопасности и эффективности терапии
    • Специалист по фармаконадзору
    • Менеджер проектов в фармацевтической компании

    Средний доход в Европе:
    от €50,000 до €95,000 в год, в зависимости от специализации и страны.


    Почему выбирают нас?
    • Европейский диплом, признанный во всех странах ЕС
    • Гибкий формат обучения — очно или дистанционно
    • Современные лаборатории и цифровые симуляторы
    • Преподаватели с опытом работы в международных фармкомпаниях
    • Стажировки и исследовательская практика
    • Обучение на английском или русском языке

    Фармакология — это точная наука с глобальным влиянием. Мы готовим специалистов, которые стоят за созданием и контролем новых лекарств, способных изменить жизнь миллионов.

    Как поступить?
    Приёмная комиссия поможет вам выбрать подходящую форму обучения, собрать документы и пройти весь путь поступления шаг за шагом.
  `,
};
